import styled from "@emotion/styled";
import { Modal, Tab } from "react-bootstrap";
import { IStyledComponentProps } from "../../../theme/theme.types";

const AdminModalPane = styled(Tab.Pane)<IStyledComponentProps>`
  &.admin-modal-pane {
    .form-container {
      padding-top: 20px;
      .form-label {
        &.radio-heading {
          margin-bottom: 12px;
        }
        span {
          padding-left: 12px;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
`;

export default {
  AdminModalPane,
};
